/**
 * The underlying color used to implement the `inProgress` severity.
 *
 * Adding 'inProgress' as a custom color requires a custom palette entry for it to be used in Chip: https://github.com/mui/material-ui/issues/37676
 *
 * To work around this, we'll normalize it to an existing, unused palette color ("info") before passing it into
 * the MUI component, allowing us to more easily implement these styles in styleOverrides.
 */
export const inProgressColor = 'info';

const chipPaletteColors = [
  'primary',
  'secondary',
  'error',
  inProgressColor,
  'success',
  'warning',
] as const;
export type ChipPaletteColor = (typeof chipPaletteColors)[number];

// Checks if [color] is one of the default color options.
export function isChipPaletteColor(color: string): color is ChipPaletteColor {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return chipPaletteColors.includes(color as ChipPaletteColor);
}
